import React, { Fragment, Component } from 'react';
import { Container, Row, Col, Carousel } from 'react-bootstrap';

class ContactUs extends Component {
    state = {
        ContactForm: {
            email: {
                elementType: 'input',
                variant: 'outlined',
                label: 'Email',
                elementConfig: {
                    maxLength: 30,
                },
                type: "text",
                name: 'email',
                value: '',
                validation: {
                    type: 'text',
                    required: true,
                },
                color: '#212529'
            },
            subject: {
                elementType: 'select',
                variant: 'outlined',
                label: 'Subject',
                name: 'subject',
                elementConfig: {
                    required: true,
                    options: [
                        { value: 'product', displayValue: 'Product' },
                        { value: 'order', displayValue: 'Order' },
                        { value: 'delivery', displayValue: 'Delivery' },
                        { value: 'technical', displayValue: 'Technical' },
                        { value: 'marketing', displayValue: 'Marketing & Advertising Collaborations' },
                        { value: 'others', displayValue: 'Others' }
                    ]
                },
                value: ' ',
                validation: {
                    type: 'select',
                    required: true,
                    minLength: 3,
                    maxLength: 100
                },
            },
            message: {
                elementType: 'multiline',
                variant: 'outlined',
                label: 'Message',
                elementConfig: {
                    maxLength: 100,
                },
                name: 'message',
                value: '',
                validation: {
                    type: 'text',
                    required: true,
                },
                color: '#212529'
            },
        }
    }

    render() {
        return (
            <Fragment>
                <div className="contact-bg">


                </div>
                Contact Us
            </Fragment>
        )
    }

}

export default ContactUs